import { Component, OnInit, ViewChild } from '@angular/core';
import { VnaCallerIdService } from '../../services/vna-caller-id.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PaginationComponent } from 'app/shared/components/pagination/pagination.component';
import { DatesParserService } from 'app/core/service/dates_parser.service';
import { ModalService } from 'ngx-dynamic-modal';
import { CallerIdCampaignsComponent } from '../../modals/caller-id-campaigns/caller-id-campaigns.component';
import * as _ from 'underscore';
import * as moment from 'moment';
import { Angular2Csv } from 'angular2-csv';
import { AuthService } from 'app/core/service/auth.service';

@Component({
  selector: 'app-verification-caller-ids',
  templateUrl: './verification-caller-ids.component.html',
  styleUrls: ['./verification-caller-ids.component.scss']
})
export class VerificationCallerIdsComponent implements OnInit {

  formFilter: FormGroup;
  loading = false;
  rows: Array<Object> = [];
  headers: string[] = [];
  temp: Array<Object> = [];
  tableSearchText = '';

  startAt = 0;
  endAt = 0;
  perPage = 10;

  submitted = false;

  @ViewChild(PaginationComponent) pagination: PaginationComponent;

  constructor(private callerIdsService: VnaCallerIdService, private fb: FormBuilder, private datesParser: DatesParserService,
      private modalService: ModalService, private authService: AuthService) {

    const currentDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
    this.formFilter = this.fb.group({
      called_start_date: [currentDate + ' 00:00:00', Validators.required],
      called_end_date: [currentDate + ' 23:59:59', Validators.required],
      service_campaign_pks: [],
      service_campaign_action_pk: []
    })
  }

  ngOnInit() {

  }

  hasClientPk(): boolean {
    return this.authService.getClient() > 0;
  }

  showCallerIdCampaigns(row: object): void {
    this.modalService.addDynamicComponent(CallerIdCampaignsComponent, { caller_id: row['caller_id']});
  }

  loadCallerIdsVerifications() {

    if (!this.formFilter.valid) {
      this.submitted = true;
      return;
    }

    this.loading = true;
    this.rows = [];
    const queryDates = this.datesParser.cleanDates(this.formFilter.value, ['called_start_date', 'called_end_date'], false);
    if (queryDates.hasOwnProperty('service_campaign_pks') && _.isArray(queryDates['service_campaign_pks'])
      && queryDates['service_campaign_pks'].length > 0) {
        queryDates['service_campaign_pks'] = queryDates['service_campaign_pks'].map( (o: any) => {
          return o['pk'];
        });
    }

    this.callerIdsService.getCallerIdsVerifications(queryDates).subscribe(
      (result: any) => {
        this.rows = result['data'];
        this.headers = result['headers'];
        this.temp = [...result['data']];
        this.endAt = (!this.haveToPaginate()) ? this.rows.length : this.perPage;
        this.loading = false;
      }
    )
  }

  reportToCsv(): void {
    let headers = {'caller_id' : 'Caller id', 'hiya': 'Hiya', 'shouldanswer' : 'Should Answer', 'google' : 'Google', 'truecaller' : 'True caller'};
    let hKeys = _.keys(headers);
    let hLabels = _.values(headers);

    let csvRows = this.rows.map( (o) => {
        const csvRow = {};
        hKeys.forEach( (value: string) => {
            if (value === 'hiya' || value === 'shouldanswer' || value === 'google' || value === 'truecaller') {
              csvRow[value] = (o[value] === '1') ? 'YES' : 'NO';
              if (o[value] === '1') {
                csvRow[value] = 'YES';
              } else if(o[value] === '0') {
                csvRow[value] = 'NO';
              } else {
                csvRow[value] = '--';
              }

            } else {
              csvRow[value] = o[value];
            }
        } );
        return csvRow;
    });

    new Angular2Csv(csvRows, 'caller_ids_verification_report_' + moment().unix(), {
        'showLabels' : true,
        'headers' : hLabels
    });
}

  goToPage(n: number) {
    if (this.pagination) {
        this.startAt = this.pagination.getStart();
        this.endAt = this.pagination.getEnd();
    }
  }

  haveToPaginate(): boolean {
    return this.perPage < this.rows.length;
  }

  updateFilter(event) {
    this.tableSearchText = event.target.value.toLowerCase();
    const temp = this.temp.filter((d) => {
        return d['caller_id'].toLowerCase().indexOf(this.tableSearchText) !== -1 || !this.tableSearchText;
    });

    this.rows = temp;
}

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/components/verification-caller-ids/verification-caller-ids.component.ts